import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { tag_posts } from "../../redux/actions";
import SinglePostCard from "../../components/singlePostCard";

export default function TagPosts() {
  const globalState = useSelector((state) => state);
  const dispatch = useDispatch();
  const params = useParams();
  useEffect(() => {
    dispatch(tag_posts("get", `${process.env.REACT_APP_URL}/api/articles?tag=${params.tag}`));
  }, [])
  return globalState.tagPosts ? (
    globalState.tagPosts.map((item, index) => (
      <SinglePostCard key={index} item={item} />
    ))
  ) : (
    <div>Loading...</div>
  );
}
